import { Box, CircularProgress, Grid } from '@mui/material';

export const Progress = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignContent="center"
      data-testid="loading">
      <Box
        style={{
          position: 'absolute',
          top: '45%',
        }}>
        <CircularProgress />
      </Box>
    </Grid>
  );
};

export const ProgressBox = ({ loading = true }: { loading: boolean }) => {
  return (
    <Box bgcolor="brand.disabled" width="78%" height="80%" data-testid="BgBox">
      {loading && <Progress />}
    </Box>
  );
};
